import { render, staticRenderFns } from "./SensorCO2.vue?vue&type=template&id=205ab868&scoped=true&"
import script from "./SensorCO2.vue?vue&type=script&lang=ts&"
export * from "./SensorCO2.vue?vue&type=script&lang=ts&"
import style0 from "./SensorCO2.vue?vue&type=style&index=0&id=205ab868&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205ab868",
  null
  
)

export default component.exports